import {
  SET_GOOD_ORDER_LIST,
  SET_GOOD_ORDER_LOADING,
  SET_APPS_ORDER_LOADING,
  SET_APPS_ORDER_LIST,
  EMPTY_ORDER_LIST,
  SET_GAME_LIST,
  SET_GAME_LIST_LOADING,
} from '../constants/order';

const initState = {
  mallOrders: [],
  mallTotal: 0,
  mallLoading: false,
  appOrders: [],
  appTotal: 0,
  appLoading: false,
  gameList: [],
  gameTotal: 0,
  gameLoading: false,
};

const order = (state = initState, action = {}) => {
  switch (action.type) {
    case SET_GOOD_ORDER_LIST:
      return {
        ...state,
        mallOrders: action.payload.params.refresh
          ? action.payload.list
          : [...state.mallOrders, ...action.payload.list],
        mallTotal: action.payload.total,
      };
    case SET_GOOD_ORDER_LOADING:
      return { ...state, mallLoading: action.loading };
    case SET_APPS_ORDER_LIST:
      return {
        ...state,
        appOrders: action.payload.params.refresh
          ? action.payload.list
          : [...state.appOrders, ...action.payload.list],
        appTotal: action.payload.total,
      };
    case SET_APPS_ORDER_LOADING:
      return { ...state, appLoading: action.loading };
    case EMPTY_ORDER_LIST:
      return {
        ...state,
        mallOrders: [],
        mallTotal: 0,
        mallLoading: false,
        appOrders: [],
        appTotal: 0,
        appLoading: false,
      };

    case SET_GAME_LIST:
      return {
        ...state,
        gameList: action.payload.list,
        gameTotal: action.payload.total,
      };
    case SET_GAME_LIST_LOADING:
      return {
        ...state,
        gameLoading: action.loading,
      };
    default:
      return state;
  }
};

export default order;
